'use strict';

function readDir(file, optResolver, onRead) {
  // Do nothing for now
  onRead();
}

module.exports = readDir;
